(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1309],{

/***/ 75400:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87596);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 7335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_isMuiElement; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/isMuiElement.js

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/react.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/isMuiElement.js

/* harmony default export */ var utils_isMuiElement = (isMuiElement);

/***/ }),

/***/ 47505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57094);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 57577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58290);

/* harmony default export */ __webpack_exports__["Z"] = (_mui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);

/***/ }),

/***/ 44591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_useControlled; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@mui/utils/esm/useControlled.js
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = react.useRef(controlled !== undefined);
  const [valueState, setValue] = react.useState(defaultProp);
  const value = isControlled ? controlled : valueState;

  if (false) {}

  const setValueIfUncontrolled = react.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}
;// CONCATENATED MODULE: ./node_modules/@mui/material/esm/utils/useControlled.js

/* harmony default export */ var utils_useControlled = (useControlled);

/***/ }),

/***/ 49064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createChainedFunction; }
/* harmony export */ });
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }

    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}

/***/ }),

/***/ 87596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ debounce; }
/* harmony export */ });
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func, wait = 166) {
  let timeout;

  function debounced(...args) {
    const later = () => {
      func.apply(this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = () => {
    clearTimeout(timeout);
  };

  return debounced;
}

/***/ }),

/***/ 58290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ownerWindow; }
/* harmony export */ });
/* harmony import */ var _ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57094);

function ownerWindow(node) {
  const doc = (0,_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(node);
  return doc.defaultView || window;
}

/***/ }),

/***/ 57579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

let globalId = 0;

function useGlobalId(idOverride) {
  const [defaultId, setDefaultId] = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride);
  const id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the incrementing value for client-side rendering only.
      // We can't use it server-side.
      // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
      globalId += 1;
      setDefaultId(`mui-${globalId}`);
    }
  }, [defaultId]);
  return id;
} // eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814


const maybeReactUseId = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))['useId' + ''];
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */

function useId(idOverride) {
  if (maybeReactUseId !== undefined) {
    const reactId = maybeReactUseId();
    return idOverride != null ? idOverride : reactId;
  } // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.


  return useGlobalId(idOverride);
}

/***/ }),

/***/ 46063:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article",
      function () {
        return __webpack_require__(78852);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61953);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}


const CursorBox = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (CursorBox);


/***/ }),

/***/ 46895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79072);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61225);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62097);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 0;\n  margin-bottom: 0;\n\n  & > .MuiGrid-item {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}






const StyledGrid = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_templateObject());
const GutterGrid = (param)=>{
    let { xs , md , lg , xl , ...rest } = param;
    // const isSM = useMediaQuery({ minWidth: 576, maxWidth: 767 })
    const theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    const isMD = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.between("md", "lg"));
    const isLG = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.between("lg", "xl"));
    const isXL = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(theme.breakpoints.up("xl"));
    const defaultSpacing = xs ? 2 : 0;
    const [spacing, setSpacing] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultSpacing);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isMD) {
            md && setSpacing(4);
        } else if (isLG) {
            lg && setSpacing(6);
        } else if (isXL) {
            xl && setSpacing(8);
        } else {
            xs && setSpacing(defaultSpacing);
        }
    }, [
        isMD,
        isLG,
        isXL
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
        container: true,
        spacing: spacing,
        ...rest
    });
};
GutterGrid.defaultProps = {
    xs: true,
    md: true,
    lg: true,
    xl: true
};
/* harmony default export */ __webpack_exports__["Z"] = (GutterGrid);


/***/ }),

/***/ 26643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77366);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_hooks_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53258);
/* harmony import */ var use_deep_compare_effect__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87620);
/* harmony import */ var utils_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13946);
/* harmony import */ var components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98780);
/*
 * 配合react-infinite-scroll-component使用
 * 當需要scrollableTarget時(在element scroll而不是window)
 * 須給定element實際的height pixel
 */ 
function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  overflow-y: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  height: ",
        "px;\n  overflow-y: auto;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}








const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject());
const HeightSyncToContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div(_templateObject1(), (props)=>props.height);
const InfiniteContainer = (param)=>{
    let { children , id , containerRef , filterState ={} , ...rest } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const { page  } = (router === null || router === void 0 ? void 0 : router.query) || {};
    const [node, nodeRef] = (0,utils_hooks_dom__WEBPACK_IMPORTED_MODULE_5__/* .useStateRef */ .Y)();
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)();
    const scrollableRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    const { showButton , showScrollButton  } = (0,utils_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useShowScrollToTopButton */ .zi)();
    // 判斷當有頁面 query 且改變時為點擊換頁，使頁面置頂
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((router === null || router === void 0 ? void 0 : router.pathname) === "/vender" && page) {
            setTimeout(()=>{
                var _scrollableRef_current;
                return (scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) && (scrollableRef === null || scrollableRef === void 0 ? void 0 : (_scrollableRef_current = scrollableRef.current) === null || _scrollableRef_current === void 0 ? void 0 : _scrollableRef_current.scrollTo({
                    top: 0,
                    behavior: "smooth"
                }));
            }, 0);
        }
    }, [
        page,
        filterState
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if ((scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current) && containerRef) {
            containerRef.current = scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current;
        }
    }, [
        scrollableRef === null || scrollableRef === void 0 ? void 0 : scrollableRef.current,
        containerRef
    ]);
    const handleResize = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        if (node) {
            setHeight(node.clientHeight);
        }
    }, [
        node
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!node) {
            return;
        }
        const observer = new ResizeObserver(handleResize);
        observer.observe(node);
        return ()=>{
            observer.unobserve(node);
        };
    }, [
        node,
        handleResize
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Container, {
        ref: nodeRef,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(HeightSyncToContainer, {
            height: height,
            id: id,
            ref: scrollableRef,
            onScroll: showScrollButton,
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ScrollToTopButton__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    showButton: showButton,
                    scrollableRef: scrollableRef
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteContainer);


/***/ }),

/***/ 84070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73221);



const NoindexRemoval = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
            children: config_constants__WEBPACK_IMPORTED_MODULE_2__/* .APP_ENV */ .Wi === "prod" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {}, "noindex")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoindexRemoval);


/***/ }),

/***/ 2925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  ",
        ";\n  line-height: ",
        ";\n  height: ",
        ";\n  text-align: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const NowrapDiv = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), (param)=>{
    let { $lines  } = param;
    return !!$lines && $lines > 1 ? "display: -webkit-box;" + "-webkit-line-clamp: ".concat($lines, ";") + "-webkit-box-orient: vertical;" : "white-space: nowrap;";
}, (param)=>{
    let { $fixHeight  } = param;
    return $fixHeight ? "1.2em" : "";
}, (param)=>{
    let { $lines , $fixHeight  } = param;
    return $fixHeight ? ($lines || 1) * 1.2 + "em" : "auto";
}, (param)=>{
    let { $textCenter  } = param;
    return $textCenter ? "center" : "left";
});
/* harmony default export */ __webpack_exports__["Z"] = (NowrapDiv);


/***/ }),

/***/ 25133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ OneLineGrid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75084);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79072);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29630);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79592);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n  overflow-y: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






const OneLineGrid = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_templateObject(), (param)=>{
    let { $height  } = param;
    return $height || "72px";
}, (param)=>{
    let { $width  } = param;
    return $width;
});
const StyledButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme , size , shape  } = param;
    return "\n    border-radius: 25px;\n    font-size: 14px;\n    color: ".concat(theme.palette.text.minus2, ";\n    background: ").concat(theme.palette.grey.third, ";\n    padding: ").concat({
        sm: "10px 12px",
        md: "10px 16px",
        lg: "12px 20px",
        xl: "12px 20px"
    }[size], ";\n    border-radius: ").concat({
        round: "20px",
        rectangle: "6px"
    }[shape], "\n\n    &:hover {\n      background-color: ").concat(theme.palette.primary.bgPlus1, ";\n      box-shadow: none; // shadow override worked here only in ios browser\n    }\n    &:active {\n      background-color: ").concat(theme.palette.primary.main, ";\n      color: #ffffff;\n    }\n  ");
});
const TagButton = (param)=>{
    let { href , children , shape ="round" , size ="md" , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        href: href || "",
        $origin: true,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
            variant: "contained",
            color: "grey",
            shape: shape,
            size: size,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                sx: {
                    typography: {
                        sm: "bodyXs",
                        md: "bodySmall",
                        lg: "bodyMedium",
                        xl: "bodyLarge"
                    }[size]
                },
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TagButton);


/***/ }),

/***/ 78852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ article; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./components/common/InfiniteContainer/index.js
var InfiniteContainer = __webpack_require__(26643);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./utils/api/hooks/useArticleLayout.js
var useArticleLayout = __webpack_require__(36558);
// EXTERNAL MODULE: ./utils/api/hooks/useArticles.js
var useArticles = __webpack_require__(56168);
// EXTERNAL MODULE: ./utils/api/hooks/useArticleClassifications.js
var useArticleClassifications = __webpack_require__(92437);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./utils/native-notifier.js
var native_notifier = __webpack_require__(11634);
// EXTERNAL MODULE: ./components/common/Layout/index.js
var Layout = __webpack_require__(82023);
// EXTERNAL MODULE: ./components/common/Header/index.js + 2 modules
var Header = __webpack_require__(75883);
// EXTERNAL MODULE: ./components/common/Footer/index.js + 12 modules
var Footer = __webpack_require__(56007);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./components/common/GutterGrid/index.js
var GutterGrid = __webpack_require__(46895);
// EXTERNAL MODULE: ./components/common/Hidden/index.js
var Hidden = __webpack_require__(18450);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/TagButton/index.js
var TagButton = __webpack_require__(25133);
// EXTERNAL MODULE: ./components/common/SVGElements/SVG.js
var SVG = __webpack_require__(54806);
;// CONCATENATED MODULE: ./components/common/SVGElements/NavRightArrow.js


const NavRightArrowSVG = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SVG/* default */.Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
            className: "arrow-right",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fillRule: "evenodd",
                d: "M12.707 4.293a1 1 0 10-1.414 1.414L16.586 11H5a1 1 0 100 2h11.586l-5.293 5.293a1 1 0 001.414 1.414l7-7a1 1 0 000-1.414l-7-7z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};

// EXTERNAL MODULE: ./components/common/NowrapDiv/index.js
var NowrapDiv = __webpack_require__(2925);
// EXTERNAL MODULE: ./components/common/CursorPointerBox.js/index.js
var CursorPointerBox_js = __webpack_require__(69443);
;// CONCATENATED MODULE: ./components/pages/Article/Index/ArticleCard.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-top: 50%;\n  padding-top: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: ",
        ";\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}







const ImgRect = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject(), (param)=>{
    let { $flat  } = param;
    return $flat ? "50%" : "75%";
});
const Absolute = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
const Img = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject2(), (param)=>{
    let { theme , $src , $hasRadius  } = param;
    return "\n    border-radius: ".concat($hasRadius ? theme.spacing(2.5) : "0", ";\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  ");
});
const StyledNowrapDiv = (0,emotion_styled_browser_esm/* default */.Z)(NowrapDiv/* default */.Z)(_templateObject3(), (param)=>{
    let { $alignRight  } = param;
    return $alignRight ? "right" : "initial";
});
const ArticleCard = (param)=>{
    let { article , main , sixth  } = param;
    if (!article) {
        // TODO: Skeleton
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgRect, {
                    $flat: !!sixth
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mt: 4,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: main ? "h4" : "h6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                            $lines: 3,
                            $fixHeight: true
                        })
                    })
                })
            ]
        });
    }
    const image = (article === null || article === void 0 ? void 0 : article.mediumImage) || (article === null || article === void 0 ? void 0 : article.image);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
        href: "/article/".concat(article === null || article === void 0 ? void 0 : article.urlId),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CursorPointerBox_js/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgRect, {
                    $flat: !!sixth,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Absolute, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                            src: image === null || image === void 0 ? void 0 : image.url,
                            $hasRadius: !!sixth
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mt: 4,
                    color: "text.minus2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: main ? "h4" : "h6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNowrapDiv, {
                            $lines: 3,
                            $fixHeight: !main,
                            $alignRight: !!sixth,
                            children: article === null || article === void 0 ? void 0 : article.title
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Index_ArticleCard = (ArticleCard);

;// CONCATENATED MODULE: ./components/pages/Article/Index/ArticleClassificationSwiper.js

function ArticleClassificationSwiper_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    ArticleClassificationSwiper_templateObject = function() {
        return data;
    };
    return data;
}















const modules = [
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Autoplay */.pt
];
const ArticleSwiper = (0,emotion_styled_browser_esm/* default */.Z)(swiper_react/* Swiper */.tq)(ArticleClassificationSwiper_templateObject(), (param)=>{
    let { theme  } = param;
    return "\n    .swiper-wrapper {\n      ".concat(theme.breakpoints.down("lg"), " {\n        margin-left: ").concat(theme.spacing(4), ";\n      }\n    }\n\n    .swiper-slide {\n      ").concat(theme.breakpoints.down("lg"), " {\n        width: 252px;\n      }\n    }\n  ");
});
const articleSwiperBreakpoints = {
    992: {
        spaceBetween: 24,
        slidesPerGroup: 4,
        slidesPerView: 4
    }
};
const ArticleClassificationSwiper = (param)=>{
    let { classification  } = param;
    var _classification_keywords, _classification_keywords1;
    const { data: articles , isLoading  } = (0,useArticles/* useArticles */.l)({
        articleClassificationIds: [
            classification === null || classification === void 0 ? void 0 : classification._id
        ],
        limit: 8
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
        mt: {
            xs: 12,
            lg: 25
        },
        $xs: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
                mb: 8,
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center",
                $lg: false,
                $xl: false,
                $xxl: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        flexGrow: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                fontWeight: "fontWeightBold",
                                display: "flex",
                                alignItems: "center",
                                color: "text.minus2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        whiteSpace: "nowrap",
                                        children: classification.name
                                    }),
                                    !!((_classification_keywords = classification.keywords) === null || _classification_keywords === void 0 ? void 0 : _classification_keywords.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hidden/* HideInMobileBox */.dz, {
                                        display: "flex",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                px: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    height: "14px",
                                                    width: "2px",
                                                    bgcolor: "background.line"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TagButton/* OneLineGrid */.$, {
                                                container: true,
                                                spacing: 2,
                                                alignItems: "center",
                                                children: (_classification_keywords1 = classification.keywords) === null || _classification_keywords1 === void 0 ? void 0 : _classification_keywords1.map((keyword)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                        item: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagButton/* default */.Z, {
                                                            href: "/article/tag/".concat(keyword.urlId),
                                                            children: keyword.name
                                                        })
                                                    }, keyword._id))
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                        href: "/article-classification/".concat(classification === null || classification === void 0 ? void 0 : classification.urlId),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textSecondary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                display: "flex",
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                        mr: 3,
                                        children: [
                                            "更多",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                                component: "span",
                                                children: classification.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavRightArrowSVG, {
                                        textSecondary: true
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSwiper, {
                modules: modules,
                slidesPerView: "auto",
                slidesPerGroup: 1,
                spaceBetween: 8,
                navigation: true,
                breakpoints: articleSwiperBreakpoints,
                children: isLoading || !(articles === null || articles === void 0 ? void 0 : articles.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleCard, {})
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: articles === null || articles === void 0 ? void 0 : articles.map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleCard, {
                                article: article
                            })
                        }, article._id))
                })
            })
        ]
    }, classification._id);
};
/* harmony default export */ var Index_ArticleClassificationSwiper = (ArticleClassificationSwiper);

;// CONCATENATED MODULE: ./components/pages/Article/Index/index.js

function Index_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: none;\n"
    ]);
    Index_templateObject = function() {
        return data;
    };
    return data;
}
function Index_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 1;\n  ",
        "\n"
    ]);
    Index_templateObject1 = function() {
        return data;
    };
    return data;
}
function Index_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 2;\n  ",
        "\n"
    ]);
    Index_templateObject2 = function() {
        return data;
    };
    return data;
}
function Index_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 3;\n"
    ]);
    Index_templateObject3 = function() {
        return data;
    };
    return data;
}



















const MainGrid = (0,emotion_styled_browser_esm/* default */.Z)(GutterGrid/* default */.Z)(Index_templateObject());
const FirstGrid = (0,emotion_styled_browser_esm/* default */.Z)(Grid/* default */.ZP)(Index_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      order: 2;\n    }\n  ");
});
const SecondGrid = (0,emotion_styled_browser_esm/* default */.Z)(Grid/* default */.ZP)(Index_templateObject2(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      order: 1;\n    }\n  ");
});
const ThirdGrid = (0,emotion_styled_browser_esm/* default */.Z)(Grid/* default */.ZP)(Index_templateObject3());
const ArticleIndex = (param)=>{
    let { fallbackData  } = param;
    const { data: layout , isLoading: isLayoutLoading  } = (0,useArticleLayout/* useArticleLayout */.o)("mainArticles", {
        fallbackData: [
            fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.layout
        ]
    });
    const { data: alternateArticles  } = (0,useArticles/* useArticles */.l)(()=>{
        var _layout_mainArticles, _layout_mainArticles1;
        return !isLayoutLoading && (layout === null || layout === void 0 ? void 0 : (_layout_mainArticles = layout.mainArticles) === null || _layout_mainArticles === void 0 ? void 0 : _layout_mainArticles.length) < 6 ? {
            limit: 6 - ((layout === null || layout === void 0 ? void 0 : (_layout_mainArticles1 = layout.mainArticles) === null || _layout_mainArticles1 === void 0 ? void 0 : _layout_mainArticles1.length) || 0)
        } : null;
    }, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.alternateArticles
    });
    const specialArticles = layout === null || layout === void 0 ? void 0 : layout.mainArticles.concat(alternateArticles || []);
    const { data: categories  } = (0,useArticleClassifications/* useArticleClassifications */.$)(null, {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.articleClassifications
    });
    const firstGroupOfCategories = (categories || []).slice(0, 2);
    const restOfCategories = (categories || []).slice(2);
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    (0,react.useEffect)(()=>{
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
            try {
                (0,native_notifier/* enableNativeHeaderMainTabs */.QL)(true);
                (0,native_notifier/* enableNativeHeaderNavBack */.Gz)(false);
                (0,native_notifier/* enableNativeHeaderSearch */.PP)(true);
            } catch (err) {
                console.error("native notifier error: ", err.message);
            }
        }
    }, [
        webview
    ]);
    const containerId = "article-homepage-scrollable";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        stickyHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
        fixContentHeight: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfiniteContainer/* default */.Z, {
            id: containerId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                    mt: {
                        xs: 3,
                        lg: 12
                    },
                    pb: 10,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainGrid, {
                        xs: false,
                        md: false,
                        lg: false,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstGrid, {
                                item: true,
                                xs: 12,
                                lg: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleCard, {
                                    article: specialArticles === null || specialArticles === void 0 ? void 0 : specialArticles[0],
                                    main: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondGrid, {
                                item: true,
                                xs: 12,
                                lg: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    mt: {
                                        xs: 14,
                                        lg: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        container: true,
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 6,
                                                lg: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleCard, {
                                                    article: specialArticles === null || specialArticles === void 0 ? void 0 : specialArticles[1]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 6,
                                                lg: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    mt: {
                                                        xs: 0,
                                                        lg: 12
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleCard, {
                                                        article: specialArticles === null || specialArticles === void 0 ? void 0 : specialArticles[2]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdGrid, {
                                item: true,
                                xs: 12,
                                lg: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    mt: {
                                        xs: 14,
                                        lg: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        container: true,
                                        spacing: 2,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 6,
                                                lg: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleCard, {
                                                    article: specialArticles === null || specialArticles === void 0 ? void 0 : specialArticles[3]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                xs: 6,
                                                lg: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                    mt: {
                                                        xs: 0,
                                                        lg: 12
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleCard, {
                                                        article: specialArticles === null || specialArticles === void 0 ? void 0 : specialArticles[4]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                }),
                firstGroupOfCategories === null || firstGroupOfCategories === void 0 ? void 0 : firstGroupOfCategories.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleClassificationSwiper, {
                        classification: category
                    }, category._id)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper/* default */.Z, {
                    mt: {
                        xs: 16,
                        lg: 24
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileGrid */.W, {
                                item: true,
                                lg: 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                lg: 10,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleCard, {
                                    article: specialArticles === null || specialArticles === void 0 ? void 0 : specialArticles[5],
                                    sixth: true
                                })
                            })
                        ]
                    })
                }),
                restOfCategories === null || restOfCategories === void 0 ? void 0 : restOfCategories.map((category)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.ZP, {
                        height: 390,
                        offset: 200,
                        scrollContainer: "#".concat(containerId),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_ArticleClassificationSwiper, {
                            classification: category
                        })
                    }, category._id)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mt: 16
                }),
                (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
            ]
        })
    });
};
/* harmony default export */ var Index = (ArticleIndex);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(73221);
;// CONCATENATED MODULE: ./components/pages/Article/Index/MetaTags.js



const MetaTags = (param)=>{
    let { resolvedUrl , article  } = param;
    var _article_image;
    const pathName = resolvedUrl.split("?")[0];
    const title = "精選居家生活知識與經典文章，讓生活變得更美好 - 信義居家";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: "".concat(constants/* LS_APP_DOMAIN */._8 + pathName)
            }, "canonical"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: title
            }, "title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: "信義居家蒐集各種居家生活知識與經典文章：室內設計經典案例、實際裝潢案例分享、裝潢知識蒐集、居家風水佈置介紹、家事清潔小技巧等居家生活文章都再信義居家"
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: "信義居家蒐集各種居家生活知識與經典文章：室內設計經典案例、實際裝潢案例分享、裝潢知識蒐集、居家風水佈置介紹、家事清潔小技巧等居家生活文章都再信義居家"
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: (article === null || article === void 0 ? void 0 : (_article_image = article.image) === null || _article_image === void 0 ? void 0 : _article_image.url) || ""
            }, "og:image")
        ]
    });
};
/* harmony default export */ var Index_MetaTags = (MetaTags);

// EXTERNAL MODULE: ./utils/withLivingSinyi.js + 8 modules
var withLivingSinyi = __webpack_require__(93756);
// EXTERNAL MODULE: ./components/common/NoindexRemoval/index.js
var NoindexRemoval = __webpack_require__(84070);
;// CONCATENATED MODULE: ./pages/article/index.js





const ArticlesPage = (props)=>{
    var _props_fallbackData, _props_fallbackData_layout, _props_fallbackData_layout_mainArticles;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoindexRemoval/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Index_MetaTags, {
                resolvedUrl: props.resolvedUrl,
                article: (_props_fallbackData = props.fallbackData) === null || _props_fallbackData === void 0 ? void 0 : (_props_fallbackData_layout = _props_fallbackData.layout) === null || _props_fallbackData_layout === void 0 ? void 0 : (_props_fallbackData_layout_mainArticles = _props_fallbackData_layout.mainArticles) === null || _props_fallbackData_layout_mainArticles === void 0 ? void 0 : _props_fallbackData_layout_mainArticles[0]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Index, {
                ...props
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var article = ((0,withLivingSinyi/* default */.Z)(ArticlesPage));


/***/ }),

/***/ 92437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useArticleClassifications; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useArticleClassifications = function() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        limit: 999
    }, swrOptions = arguments.length > 1 ? arguments[1] : void 0;
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)("/articleClassifications?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(props)), swrOptions);
};


/***/ }),

/***/ 36558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useArticleLayout; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);
/* harmony import */ var utils_request__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72673);



const useArticleLayout = (type, swrOptions)=>{
    const { data , ...rest } = (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)("/articleLayouts?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)({
        type
    })), utils_request__WEBPACK_IMPORTED_MODULE_2__/* .lsGet */ .UY, swrOptions);
    return {
        data: data === null || data === void 0 ? void 0 : data[0],
        ...rest
    };
};


/***/ }),

/***/ 56168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useArticles; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useArticles = (props, swrOptions)=>{
    const genUrl = ()=>{
        try {
            const propsObject = typeof props === "function" ? props() : props;
            if (propsObject === null) {
                return null;
            }
            return "/articles?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(propsObject));
        } catch (err) {
            return null;
        }
    };
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWR */ .LW)(genUrl, swrOptions);
};


/***/ }),

/***/ 87620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ useDeepCompareEffect; }
});

// UNUSED EXPORTS: useDeepCompareEffectNoCheck, useDeepCompareMemoize

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/dequal/dist/index.mjs
var has = Object.prototype.hasOwnProperty;

function find(iter, tar, key) {
	for (key of iter.keys()) {
		if (dequal(key, tar)) return key;
	}
}

function dequal(foo, bar) {
	var ctor, len, tmp;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (ctor === Set) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len;
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!bar.has(tmp)) return false;
			}
			return true;
		}

		if (ctor === Map) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len[0];
				if (tmp && typeof tmp === 'object') {
					tmp = find(bar, tmp);
					if (!tmp) return false;
				}
				if (!dequal(len[1], bar.get(tmp))) {
					return false;
				}
			}
			return true;
		}

		if (ctor === ArrayBuffer) {
			foo = new Uint8Array(foo);
			bar = new Uint8Array(bar);
		} else if (ctor === DataView) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo.getInt8(len) === bar.getInt8(len));
			}
			return len === -1;
		}

		if (ArrayBuffer.isView(foo)) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo[len] === bar[len]);
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}

;// CONCATENATED MODULE: ./node_modules/use-deep-compare-effect/dist/use-deep-compare-effect.esm.js



function checkDeps(deps) {
  if (!deps || !deps.length) {
    throw new Error('useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.');
  }

  if (deps.every(isPrimitive)) {
    throw new Error('useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.');
  }
}

function isPrimitive(val) {
  return val == null || /^[sbn]/.test(typeof val);
}
/**
 * @param value the value to be memoized (usually a dependency list)
 * @returns a momoized version of the value as long as it remains deeply equal
 */


function useDeepCompareMemoize(value) {
  var ref = react.useRef(value);
  var signalRef = react.useRef(0);

  if (!dequal(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  } // eslint-disable-next-line react-hooks/exhaustive-deps


  return react.useMemo(function () {
    return ref.current;
  }, [signalRef.current]);
}

function useDeepCompareEffect(callback, dependencies) {
  if (false) {} // eslint-disable-next-line react-hooks/exhaustive-deps


  return react.useEffect(callback, useDeepCompareMemoize(dependencies));
}

function useDeepCompareEffectNoCheck(callback, dependencies) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useEffect(callback, useDeepCompareMemoize(dependencies));
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3829,5897,9072,9477,231,5616,9705,6760,3997,318,9531,3756,6245,6007,7266,9774,2888,179], function() { return __webpack_exec__(46063); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);